module.exports = __webpack_public_path__ + "img/f3.737c1282.png";